import * as React from 'react';

import { Navigate } from 'react-router';
import { Scanner as QrScanner } from '@yudiel/react-qr-scanner';
import Footer from 'components/Footer';

import './Scanner.css';

interface NavigateState {
	navigate: string;
}

class Scanner extends React.Component {
	state: NavigateState = {
		navigate: '',
	};

	render() {
		return (
			<section className="scanner">
				<div className="instructions">Scan the QR code!</div>
				<QrScanner sound={false} onScan={(result) => this.onScan(result[0])} />
				{this.state.navigate && <Navigate to={this.state.navigate} />}
				<br />
				<br />
				<br />
				<br />
				<Footer />
			</section>
		);
	}

	onScan(result) {
		if ((result.rawValue as string).includes('CORRECT')) {
			this.setState({ navigate: '/correct' });
		} else {
			this.setState({ navigate: '/incorrect' });
		}
	}
}

export default Scanner;
